import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React from "react";

import { Label, Paragraph } from "@fronterahealth/frontera-ui-components";

import { EhrSyncAlertType } from "@api/graphql/types-and-hooks";
import { WarningItem } from "@components/EHRSyncAlert/WarningItem";

export interface EhrSyncAlertSectionProps {
  title: string;
  alert?: EhrSyncAlertType | null | undefined;
}

export const EhrSyncAlertSection: React.FC<EhrSyncAlertSectionProps> = ({ title, alert }) => {
  const isSectionDisplayed = Boolean(
    alert && (alert.userMessage || alert.error || (alert.warnings && alert.warnings.length)),
  );
  if (!isSectionDisplayed) return null;

  return (
    <div className="mb-5">
      <Label size="medium" colorType="primary">
        {title}
      </Label>
      <div className="flex flex-col gap-3 p-4 border rounded-sm border-limestone-100 bg-white mt-2">
        {alert?.userMessage && (
          <div className="flex items-start gap-3">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
            <div>
              <Paragraph colorType="primary">{alert.userMessage}</Paragraph>
            </div>
          </div>
        )}
        {!alert?.userMessage && alert?.error && (
          <div className="flex items-start gap-3">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
            <div>
              <Paragraph colorType="primary">
                We couldn&apos;t complete this sync. Please try again. If the issue persists, contact support.
              </Paragraph>
            </div>
          </div>
        )}
        {(!alert?.error || alert?.userMessage) && alert?.warnings && alert.warnings.length > 0 && (
          <div className="flex flex-col gap-2">
            {alert.warnings.map((w, i) => w && <WarningItem key={i} warning={w} />)}
          </div>
        )}
      </div>
    </div>
  );
};
